import React from 'react';
//import AddToCartButton from 'js/components/Shop/AddToCart/components/AddToCartButton';

import { OverlayTrigger, Tooltip } from "react-bootstrap";

/* Symbols */
import toolTip from 'symbols/tooltip.svg';

/* Atoms */
import { Icon } from "js/components/atoms";

/* Utilities */
import { currency, trans } from 'js/utilities';
import {Button} from "../atoms";

export default function CardProduct({ product, image, shopwareUrl, relatedProductsUrl, contentBlockProductsUrl, showVehicleModal, cartUrl, disableModal = false }) {
    const locale = document.documentElement.lang || 'nl';
    const productDetailUrl = `/${locale}/s/${product?.id}`;

    return (
        <a href={productDetailUrl} className="card card--link card--bordered card--product text-decoration-none">
            {image && (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip className="mb-n2">
                            {trans('product_detail.intro.fotos')}
                        </Tooltip>
                    }
                >
                    <div className="d-flex btn--tooltip">
                        <Icon
                            theme=""
                            size={20}
                            url={toolTip}
                        />
                    </div>
                </OverlayTrigger>
            )}
            <div className="card__image">
                {image?.src && (
                    <img
                        src={image.src}
                        srcSet={image.srcSet}
                        sizes={image.sizes}
                        alt={image.alt || product?.name}
                        width={image.width}
                        height={image.height}
                        className="img-fluid"
                        loading={image.loading || 'auto'}
                    />
                )}
            </div>
            <div className="card-body">
                {product?.name &&
                    <h6 className="card__title mb-0">{product.name}</h6>
                }
                {product?.productNumber && (
                    <p className="text--12 text-muted mb-2">{product.productNumber}</p>
                )}
                <div className="mt-auto">
                    <div className={`d-flex justify-content-between gap-4 mt-5 ${ disableModal ? 'flex-column' : 'align-items-center' }`}>
                        <div className="price line-height-1">
                            <p className="mb-0 font-weight-extra-bold">{currency(product?.price)}</p>
                            <span className="text--12 text-muted--80">{trans('sulu.content_block.product_overview.card.price.price_desc')}</span>
                        </div>
                        <div className="card__button">
                            <Button
                                theme="callout"
                                text={trans('sulu.content_block.product_overview.card.button.show.title')}
                                href={productDetailUrl}
                            />
                            {/*<AddToCartButton*/}
                            {/*    product={product}*/}
                            {/*    shopwareUrl={shopwareUrl}*/}
                            {/*    relatedProductsUrl={relatedProductsUrl}*/}
                            {/*    contentBlockProductsUrl={contentBlockProductsUrl}*/}
                            {/*    showVehicleModal={showVehicleModal}*/}
                            {/*    cartUrl={cartUrl}*/}
                            {/*    btnLabel={trans('sulu.content_block.product_overview.card.button.title')}*/}
                            {/*    disableModal={disableModal}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
}
